//
// Place graph markers on line/curve for the Empathy
// in Action Graph
// --------------------------------------------------

// const empathySvgs = document.querySelectorAll('.empathy-graph-svg');
const progressMarkers = document.querySelectorAll('.progress-marker');

// Get Coordinates of Empathy Graph Line
// ---------------------------------------
// The general idea is to use the SVG getPointAtLength() method on a path, which you can think of as finding a point by "pushing" a length into the "tube" that is the SVG path; we know the path's total length by the .getTotalLength() method. A binary search loop is run to find the point with a matching x value to what is passed in, and we are left with known x and y values for the desired point on the path.
// ---------------------------------------
// greatly modified from https://web.archive.org/web/20181011120958/http://bl.ocks.org/duopixel/3824661
// via https://stackoverflow.com/questions/15578146/get-y-coordinate-of-point-along-svg-path-with-given-an-x-coordinate
// ---------------------------------------
function getEmpathyGraphCurveCoordinates(marker, percentageScore) {
  //   console.log(
  //     `~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // in getEmpathyGraphCurveCoordinates. Marker: ${marker.classList}`
  //   );

  // contextual
  const mySvg = marker.closest('.svg-html-layer');
  const theCurve = mySvg.querySelector('.e_g--curve');
  const theCurveBBox = theCurve.getBBox();
  // const theCurveRect = theCurve.getBoundingClientRect();
  // const theCurveRectWidth = theCurveRect.width;
  // const theCurveRectHeight = theCurveRect.height;
  const curveLength = theCurve.getTotalLength();
  // const scale = curveLength / theCurveBBox.width;

  // console.log('mySvg:', mySvg);
  // console.log('theCurve:', theCurve);
  // console.log('theCurveBBox:', theCurveBBox);
  // console.log('theCurveRect:', theCurveRect);
  // console.log('theCurveRectWidth:', theCurveRectWidth);
  // console.log('theCurveRectHeight:', theCurveRectHeight);
  // console.log('curveLength:', curveLength);
  // console.log('scale:', scale);

  //
  // const experimentalScaledCurveLength = scale * theCurveRectWidth;
  // console.log('experimentalScaledCurveLength:', experimentalScaledCurveLength);
  //

  // convert percentageScore to a percentage width of the curve's box's width
  // console.log('percentageScore:', percentageScore);
  // const xPos = (percentageScore / 100) * theCurveRectWidth;
  const xPos = (percentageScore / 100) * theCurveBBox.width;
  // console.log('xPos:', xPos);

  // start is initialized to xPos, but will be updated to match the target if the point at target's x value is less than the mouse's relative x position
  let start = xPos;
  // end is initialized to curveLength, but will be updated to match the target if the point at target's x value is greater than the mouse's relative x position
  // let end = experimentalScaledCurveLength
  //   ? experimentalScaledCurveLength
  //   : curveLength;
  let end = curveLength;
  // see comments below
  let middle;
  // see comments below
  let pos;

  // this is a binary search — finds the point at which getPointAtLength().x is equal to desired x position (xPos). The width of the element considered and the length of the line are in most cases not the same. This helps find an appropriate "position" on the line to match the mouse's x position
  while (start <= end) {
    // target is the midpoint between the start (starting with xPos and then modified as we search) and the end (starting with the curveLength and then modified as we search)
    middle = Math.floor((start + end) / 2);
    // pos is a position, an x and y SVG coordinate, along the curve
    pos = theCurve.getPointAtLength(middle);
    // console.log(`xPos: ${xPos}. pos.x: ${pos.x}`);

    // if middle is at the end or at the start, AND the x position is NOT the same as the mouse relative x position, break
    if ((middle === end || middle === start) && pos.x !== xPos) {
      break;
    }

    // if getPointAtLength().x is greater than the mouse X rel position, set the end point to the current middle and re-run the loop
    if (pos.x > xPos) {
      end = middle;
    }
    // if getPointAtLength().x is less than the mouse X rel position, set the begining point to the current middle and re-run the loop
    else if (pos.x < xPos) {
      start = middle;
    }
    // position found -- when pos.x === xPos
    else {
      break;
    }
  }

  // console.log('pos: ', pos);
  // console.log('pos.y: ', pos.y);
  // console.log('theCurveBBox.height: ', theCurveBBox.height);
  // console.log('theCurveRectHeight: ', theCurveRectHeight);
  // console.log('pos.y / theCurveBBox.height: ', pos.y / theCurveBBox.height);

  // const relativeYPos = pos.y / theCurveBBox.height;

  // const xPct = xPos / theCurveRectWidth - 0.007;
  const xPct = xPos / theCurveBBox.width - 0.007;
  // const yPct = pos.y / theCurveRectHeight - 0.015;
  const yPct = pos.y / theCurveBBox.height - 0.015;
  // const yPct = pos.y / theCurveRectHeight;
  // console.log('yPct: ', yPct);

  return { x: xPct, y: yPct };
}

function setEmpathyProgressMarkerPosition(marker, coords) {
  marker.style.setProperty('--x', coords.x > 0 ? coords.x : 0);
  marker.style.setProperty('--y', coords.y > 1 ? 1 : coords.y);
}

/**
 * Handles the setging of all graph progress markers' coordinates — for multiple graphs on the page, and multiple markers
 * @param {Number} grandTotalScore - Generally this should always be appState.grandTotal.percentageScore, to pass that data into this module
 */
function setAllGraphProgressMarkers(grandTotalScore) {
  progressMarkers.forEach((marker) => {
    // console.log('marker: ', marker);

    // default score to the grand total
    let score = grandTotalScore;

    // if the marker is a benchmark marker, use its score instead
    if (marker.classList.contains('benchmark')) {
      score = Number(marker.dataset.benchmarkScore);
    }
    // console.log('score: ', score);

    const coords = getEmpathyGraphCurveCoordinates(marker, score);
    // console.log('coords: ', coords);
    setEmpathyProgressMarkerPosition(marker, coords);
  });
}

// graph test helper function -- animates the dot along the path to help ensure correct dot positioning
// --------------------------
// // Returns a Promise that resolves after "ms" Milliseconds
// const graphTestTimer = (ms) => new Promise((res) => setTimeout(res, ms));

// async function runGraphTest() {
//   // We need to wrap the loop into an async function for this to work
//   for (var i = 0; i <= 100; i++) {
//     // console.log(i);
//     progressMarkers.forEach((marker) => {
//       if (marker.classList.contains('you')) {
//         const coords = getEmpathyGraphCurveCoordinates(marker, i);
//         setEmpathyProgressMarkerPosition(marker, coords);
//       }
//     });
//     await graphTestTimer(60); // then the created Promise can be awaited
//   }
// }

// runGraphTest();

// Open up / allow window to call for manual testing
// window.getEmpathyGraphCurveCoordinates = getEmpathyGraphCurveCoordinates;

export default setAllGraphProgressMarkers;
